// extracted by mini-css-extract-plugin
export default {"root":"FeaturesExplorer_root__+WA8r","mobile":"FeaturesExplorer_mobile__tUkzI","list":"FeaturesExplorer_list__S1scU","item":"FeaturesExplorer_item__y-oO3"};